export default "__VITE_ASSET__CYO81VKn__"